import React, { Component } from "react";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import { toast } from "react-toastify";
import { deselectShipment } from "../../actions/select_actions";
import { dismissForm } from "../../actions/ui_actions";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import CheckBox from "../../common/Dropdowns/_CheckBox";
import CarrierSelect from "../../common/Dropdowns/_CarrierSelect";
import DateSelect from "../../common/Dropdowns/_DateSelect";
import ShipperSelect from "../../common/Dropdowns/_ShipperSelect";
import CargoTypeSelect from "../../common/Dropdowns/_CargoTypeSelect";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Formik, Form } from "formik";

class ShipmentForm extends Component {
  dismissModal = () => {
    this.props.deselectShipment();
    this.props.dismissForm();
  };

  render() {
    const {
      date,
      carrierId,
      relationId,
      cargoTypeId,
      archived
    } = this.props.shipment;

    return (
      <div>
        <Panel
          className="form-panel"
          isBlocking={true}
          isOpen={this.props.visible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.small}
          headerText="Shipment form"
          forceFocusInsideTram={false}
        >
          <Mutation
            mutation={
              this.props.addOrEdit === "edit"
                ? UPDATE_SHIPMENT
                : CREATE_SHIPMENT
            }
            refetchQueries={["allShipments"]}
          >
            {(mutate, { data }) => (
              <Formik
                onSubmit={values => {
                  const {
                    date,
                    carrierId,
                    relationId,
                    cargoTypeId,
                    archived
                  } = values;
                  const id = this.props.shipment.id;
                  mutate({
                    variables: {
                      id: id,
                      date: date,
                      carrierId: carrierId,
                      relationId: relationId,
                      cargoTypeId: cargoTypeId,
                      archived: archived
                    }
                  })
                    .then(response => {
                      toast.success(`Success ! ${response}`);
                      this.dismissModal();
                    })
                    .catch(err => {
                      toast.error(`${err}`);
                    });
                }}
                initialValues={{
                  date: date,
                  carrierId: carrierId,
                  relationId: relationId,
                  cargoTypeId: cargoTypeId,
                  archived: archived
                }}
                validate={(values, props) => {
                  const errors = {};
                  if (!values.date) {
                    errors.date = "Required";
                  }
                  if (!values.relationId) {
                    errors.relationId = "Required";
                  }
                  if (!values.carrierId) {
                    errors.carrierId = "Required";
                  }
                  if (!values.cargoTypeId) {
                    errors.cargoTypeId = "Required";
                  }
                  return errors;
                }}
                render={props => (
                  <Form>
                    <DateSelect
                      name="date"
                      label="Loading date"
                      value={props.values.date}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.date}
                      touched={props.touched.date}
                    />
                    <ShipperSelect
                      name="relationId"
                      label="Shipper"
                      value={props.values.relationId}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.relationId}
                      touched={props.touched.relationId}
                    />
                    <CarrierSelect
                      name="carrierId"
                      label="Carrier"
                      value={props.values.carrierId}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.carrierId}
                      touched={props.touched.carrierId}
                    />
                    <CargoTypeSelect
                      name="cargoTypeId"
                      label="Cargo type"
                      value={props.values.cargoTypeId}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.cargoTypeId}
                      touched={props.touched.cargoTypeId}
                    />
                    <CheckBox
                      style={{ marginTop: "20px" }}
                      label="Archived"
                      value={props.values.archived}
                      onChange={props.setFieldValue}
                      onBlur={props.setFieldTouched}
                      error={props.errors.archived}
                      touched={props.touched.carchived}
                    />
                    <Box mt={1}>
                      <PrimaryButton
                        text="Submit"
                        type="submit"
                        disable={props.isSubmitting}
                      />
                    </Box>
                  </Form>
                )}
              />
            )}
          </Mutation>
        </Panel>
      </div>
    );
  }
}

const CREATE_SHIPMENT = gql`
  mutation(
    $date: Date
    $about: String
    $carrierId: Int
    $relationId: Int
    $archived: Boolean
    $cargoTypeId: Int
  ) {
    createShipment(
      input: {
        shipment: {
          date: $date
          about: $about
          carrierId: $carrierId
          relationId: $relationId
          archived: $archived
          cargoTypeId: $cargoTypeId
        }
      }
    ) {
      shipment {
        id
        date
        about
        carrierId
        relationId
        archived
        cargoTypeId
      }
    }
  }
`;

const UPDATE_SHIPMENT = gql`
  mutation(
    $id: Int!
    $date: Date
    $about: String
    $carrierId: Int
    $relationId: Int
    $archived: Boolean
    $cargoTypeId: Int
  ) {
    updateShipmentById(
      input: {
        id: $id
        shipmentPatch: {
          date: $date
          about: $about
          carrierId: $carrierId
          relationId: $relationId
          archived: $archived
          cargoTypeId: $cargoTypeId
        }
      }
    ) {
      shipment {
        id
        date
        about
        carrierId
        relationId
        archived
        cargoTypeId
      }
    }
  }
`;



const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(
  mapStateToProps,
  {
    deselectShipment: deselectShipment,
    dismissForm: dismissForm
  }
)(ShipmentForm);



// WEBPACK FOOTER //
// ./src/common/Forms/_ShipmentForm.js